import React from "react";
import { useNavigate } from "react-router-dom";
import { reportAssetsPath } from "../server-data";
import { Button } from "@mui/material";

const ReportAsset = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const fileUrl = queryParameters.get("file")?.startsWith("http")
    ? queryParameters.get("file")
    : reportAssetsPath + queryParameters.get("file");
  const company = queryParameters.get("ao");
  const navigate = useNavigate();

  if (
    !fileUrl ||
    !company ||
    Number(company) != JSON.parse(localStorage.getItem("company") || "{}").id
  ) {
    navigate("/dashboard");
    return <div></div>;
  }
  const isImage = (url: string) => {
    return url.endsWith("jpg") || url.endsWith("png") || url.endsWith("jpeg");
  };

  const downloadReport = () => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute(
      "download",
      fileUrl.split("/")[fileUrl.split("/").length - 1]
    ); //or any other extension
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      {isImage(fileUrl) ? (
        <img
          src={fileUrl}
          alt="Report Asset"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      ) : (
        <div>
          {fileUrl.split("/")[fileUrl.split("/").length - 1]} <br />
          <Button
            variant="contained"
            style={{ color: "white" }}
            onClick={downloadReport}
          >
            Download
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReportAsset;
